var map = {
	"./PIN_TEST.png": 970,
	"./PIN_TEST2.png": 971,
	"./asd2.png": 972,
	"./atm.svg": 973,
	"./atm_pin.png": 974,
	"./cubano_logo.png": 975,
	"./cubano_pin.png": 976,
	"./de.png": 977,
	"./de_pin.png": 978,
	"./discover.svg": 979,
	"./discover_active.svg": 309,
	"./discover_gray.svg": 308,
	"./entertainment.svg": 980,
	"./entertainment_pin.png": 981,
	"./exchange.svg": 982,
	"./exchange_pin.png": 983,
	"./ezgif.com-webp-to-png.png": 984,
	"./food.svg": 985,
	"./food_pin.png": 986,
	"./history.svg": 987,
	"./history_pin.png": 988,
	"./manekin_logo.png": 989,
	"./manekin_pin.png": 990,
	"./nature.svg": 991,
	"./nature_pin.png": 992,
	"./other.svg": 993,
	"./other_pin.png": 994,
	"./teatro cubano logo.webp": 995,
	"./treasure.svg": 996,
	"./treasure_1.png": 997,
	"./treasure_2.png": 998,
	"./treasure_3.png": 999,
	"./treasure_4.png": 1000,
	"./treasure_5.png": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;